var _defs, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _path5, _circle4, _path6, _ellipse, _ellipse2, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_813",
    "data-name": "Group 813",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.301,
    height: 70.301,
    viewBox: "0 0 70.301 70.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 35.15,
    cy: 35.15,
    r: 35.15,
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 34.407,
    cy: 34.407,
    r: 34.407,
    transform: "translate(0.743 0.552)",
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M536.15,188.56s-3.9,19.218-6.03,18.153c0,0,20.534,17.737,38.666,0,0,0-3.194-13.543-7.8-18.153Z",
    transform: "translate(-514.421 -153.294)",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M549.181,271.5a34.246,34.246,0,0,0,18.914-5.66c-1.268-6.928-6.093-7.325-6.093-7.325H535.4s-4.55.373-5.975,6.749A34.25,34.25,0,0,0,549.181,271.5Z",
    transform: "translate(-513.933 -202.035)",
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.63 18.948)",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M366.42,158.88h10.643v8.514a5.32,5.32,0,0,1-5.311,5.32h0a5.32,5.32,0,0,1-5.32-5.32V158.88Z",
    transform: "translate(-336.896 -110.845)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M367.464,157.58h8.611a1.016,1.016,0,0,1,1.016,1.016v7.5a5.32,5.32,0,0,1-5.311,5.32h0a5.32,5.32,0,0,1-5.32-5.32v-7.5A1.016,1.016,0,0,1,367.464,157.58Z",
    transform: "translate(-336.924 -109.939)",
    fill: "#be7c5e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M575.77,240.977a15.317,15.317,0,0,0,10.643.03V239.7H575.77Z",
    transform: "translate(-546.225 -188.923)",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 15.253,
    cy: 15.253,
    r: 15.253,
    transform: "translate(19.63 22.257)",
    fill: "#be7c5e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M545.3,151.526h29.087s-2.484-11.744-13.479-10.995S545.3,151.526,545.3,151.526Z",
    transform: "translate(-524.997 -119.809)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(18.526 34.201)",
    fill: "#be7c5e"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 1.419,
    cy: 2.66,
    rx: 1.419,
    ry: 2.66,
    transform: "translate(48.323 34.201)",
    fill: "#be7c5e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M545.3,152.826h29.087s-2.484-11.744-13.479-10.995S545.3,152.826,545.3,152.826Z",
    transform: "translate(-524.997 -120.715)",
    opacity: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.32ad7f5c841eb221332e98b17640d577.svg";
export { ForwardRef as ReactComponent };